var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6915 7.6H18.309C18.924 7.6 19.2313 6.8555 18.7975 6.422L15.49 3.00201C15.3549 2.86686 15.1783 2.79933 15.0018 2.79933C14.8254 2.79933 14.6495 2.86686 14.5155 3.00201L11.203 6.4225C10.7693 6.855 11.0764 7.6 11.6915 7.6ZM18.3075 9.2H11.6915C11.0765 9.2 10.7693 9.94425 11.203 10.378L14.5155 13.798C14.6475 13.9325 14.8025 14 15 14C15.1763 14 15.353 13.9324 15.4883 13.7973L18.7958 10.3773C19.23 9.945 18.9225 9.2 18.3075 9.2Z",
    fill: "#767F92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 12.8,
    fill: "white",
    transform: "translate(11 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.2c2de130343812cb65c091a3d94a7ddd.svg";
export { ForwardRef as ReactComponent };